class AjaxListener {
    constructor() {
        this._ajaxCompleteFunction = undefined;
        this._ajaxErrorFunction = undefined;
        this._ajaxSendFunction = undefined;
        this._ajaxStartFunction = undefined;
        this._ajaxStopFunction = undefined;
        this._ajaxSuccessFunction = undefined;
    }

    get ajaxCompleteFunction() {
        return this._ajaxCompleteFunction;
    }

    set ajaxCompleteFunction(value) {
        this._ajaxCompleteFunction = value;
    }

    get ajaxErrorFunction() {
        return this._ajaxErrorFunction;
    }

    set ajaxErrorFunction(value) {
        this._ajaxErrorFunction = value;
    }

    get ajaxSendFunction() {
        return this._ajaxSendFunction;
    }

    set ajaxSendFunction(value) {
        this._ajaxSendFunction = value;
    }

    get ajaxStartFunction() {
        return this._ajaxStartFunction;
    }

    set ajaxStartFunction(value) {
        this._ajaxStartFunction = value;
    }

    get ajaxStopFunction() {
        return this._ajaxStopFunction;
    }

    set ajaxStopFunction(value) {
        this._ajaxStopFunction = value;
    }

    get ajaxSuccessFunction() {
        return this._ajaxSuccessFunction;
    }

    set ajaxSuccessFunction(value) {
        this._ajaxSuccessFunction = value;
    }

    ajaxEvents() {
        const _this = this;

        // Dołącz funkcję do wykonania przed wysłaniem żądania Ajax.
        jQuery(document).ajaxSend(function (event, jqxhr, settings) {
            if (Boolean(_this.ajaxSendFunction) && typeof _this.ajaxSendFunction === "function") {
                _this.ajaxSendFunction(event, jqxhr, settings);
            }
        });

        // Zarejestruj procedurę obsługi, która ma zostać wywołana, gdy rozpocznie się pierwsze żądanie Ajax.
        jQuery(document).ajaxStart(function () {
            if (Boolean(_this.ajaxStartFunction) && typeof _this.ajaxStartFunction === "function") {
                _this.ajaxStartFunction();
            }
        });

        // Zarejestruj procedurę obsługi, która ma być wywoływana po zakończeniu wszystkich żądań Ajax.
        jQuery(document).ajaxStop(function () {
            if (Boolean(_this.ajaxStopFunction) && typeof _this.ajaxStopFunction === "function") {
                _this.ajaxStopFunction();
            }
        });

        // Dołącz funkcję do wykonania za każdym razem, gdy żądanie Ajax zakończy się pomyślnie.
        jQuery(document).ajaxSuccess(function (event, xhr, settings) {
            if (Boolean(_this.ajaxSuccessFunction) && typeof _this.ajaxSuccessFunction === "function") {
                _this.ajaxSuccessFunction(event, xhr, settings);
            }
        });

        // Zarejestruj procedurę obsługi, która ma być wywoływana, gdy żądanie Ajax zakończy się błędem.
        jQuery(document).ajaxError(function (event, jqxhr, settings, thrownError) {
            if (Boolean(_this.ajaxErrorFunction) && typeof _this.ajaxErrorFunction === "function") {
                _this.ajaxErrorFunction(event, jqxhr, settings, thrownError);
            }
        });

        // Zarejestruj procedurę obsługi, która ma być wywoływana po zakończeniu żądań Ajax.
        jQuery(document).ajaxComplete(function (event, xhr, settings) {
            if (Boolean(_this.ajaxCompleteFunction) && typeof _this.ajaxCompleteFunction === "function") {
                _this.ajaxCompleteFunction(event, xhr, settings);
            }
        });
    }
}

export { AjaxListener };
